import { DatePipe } from "@angular/common";
import { Component, OnInit, HostListener } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { BnLoadingService, EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { ROLE_AGENTE_CONSULTA, ROLE_AGENTE_ENVIO, ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO } from "src/app/constantes/permissao.constants";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { SolicitacaoDevolucaoHonra } from "src/app/model/devolucao-honra.model";
import { Estado } from "src/app/model/estado.model";
import { PermissaoService } from 'src/app/shared/permissao.service';
import { SolicitacaoDevolucaoHonraService } from "../devolucao-honra.service";
import Utils from "src/app/shared/fgi-utils";
import { FileUtilsService } from "src/app/shared/file-utils.service";


@Component({
    selector: 'app-devolucao-honra-pesquisa',
    templateUrl: './devolucao-honra-pesquisa.component.html',
    standalone: false
})
export class DevolucaoHonraPesquisaComponent implements OnInit {

  private pesquisaForm: UntypedFormGroup;
  public pesquisado = false;
  public esconderPesquisa = true;

  private valoresPesquisaForm: any;
  private agentesFinanceiros: AgenteFinanceiro[] = [];
  public estados: Estado[] = [];
  public solicitacoesDevolucaoHonra: SolicitacaoDevolucaoHonra[];
  private atributosPaginacaoComponenteListagem: EntityPagedResult<SolicitacaoDevolucaoHonra>;
  private opcoesPaginacao : number[];
  public podeEscolherAgente: Boolean = false;
  public podeEnviarDevolucaoHonra: Boolean = false;
  private cnpjUsuario: string;
  private parametrosPesquisa:any = {};

  constructor(
    private formBuilder: UntypedFormBuilder,
    private loadingService: BnLoadingService,
    private datePipe: DatePipe,
    private activatedRoute: ActivatedRoute,
    private permissaoService: PermissaoService,
    private bnUsuarioService: BnUsuarioService,
    private solicitacaoDevolucaoHonraService: SolicitacaoDevolucaoHonraService,
    private fileUtils:FileUtilsService
  ) {

    this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
    this.estados = this.activatedRoute.snapshot.data['estados'];
    this.opcoesPaginacao = [10, 15, 20];
    this.atributosPaginacaoComponenteListagem = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined
    };
  }

  @HostListener('window:keydown.enter', ['$event'])
  keyEvent(event: KeyboardEvent) {
      this.buscar()
  }

  ngOnInit() {

    this.pesquisaForm = this.formBuilder.group({
      cnpjAgenteFinanceiro: null,
      idSolicitacaoDevolucao: ['', [Validators.pattern(/^[0-9]+$/), Validators.minLength(1), Validators.maxLength(36)]],
      idEstado: null,
      idExternoOperacao: ['', [Validators.pattern(/^[A-Za-z0-9_\-]+$/), Validators.minLength(1), Validators.maxLength(20)]],
      sistema: null,
      contrato: ['', [Validators.pattern(/^[0-9]+$/), Validators.minLength(11), Validators.maxLength(11)]],
      dataEnvioInicio: null,
      dataEnvioFim: null
    });

    this.bnUsuarioService.usuario$.subscribe(usuario => {
      this.cnpjUsuario = usuario?.cnpj || null
    });

    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.podeEscolherAgente = resp && resp[ROLE_GESTOR_CONSULTA];
      this.podeEnviarDevolucaoHonra = resp && (resp[ROLE_AGENTE_ENVIO]);
      this.construirFormulario();
    });
  }

  private construirFormulario() {

    const valoresSessao = sessionStorage.getItem('valoresPesquisaDevolucaoHonraForm');
    this.valoresPesquisaForm = valoresSessao ? JSON.parse(valoresSessao) : {};

    //let agenteDefault: AgenteFinanceiro;
    if (!this.podeEscolherAgente) {
      this.pesquisaForm.get('cnpjAgenteFinanceiro').disable();
    }

    this.pesquisaForm.patchValue({
      idSolicitacaoDevolucao: null,
      cnpjAgenteFinanceiro: this.agentesFinanceiros.find(a => a.cnpj==this.cnpjUsuario)?.cnpj ||null,
      idEstado: this.valoresPesquisaForm.idEstado || null,
      sistema: this.valoresPesquisaForm.sistema ? this.valoresPesquisaForm.sistema : null,
      idExternoOperacao: this.valoresPesquisaForm.idExternoOperacao ? this.valoresPesquisaForm.idExternoOperacao : null,
      contrato: this.valoresPesquisaForm.contrato ? this.valoresPesquisaForm.contrato : null,
      dataEnvioInicio: this.valoresPesquisaForm.dataEnvioInicio ? this.valoresPesquisaForm.dataEnvioInicio : null,
      dataEnvioFim: this.valoresPesquisaForm.dataEnvioFim ? this.valoresPesquisaForm.dataEnvioFim : null
    });

    this.controlaCamposDesabilitados(this.valoresPesquisaForm);

    this.pesquisaForm.valueChanges.pipe().subscribe(novosValores => {
      this.controlaCamposDesabilitados(novosValores);
      this.valoresPesquisaForm = novosValores;
      sessionStorage.setItem('valoresPesquisaDevolucaoHonraForm', JSON.stringify(this.valoresPesquisaForm));
    });
  }

  mudancaPagina(novaPagina: EntityPagedResult<SolicitacaoDevolucaoHonra>) {
    this.atributosPaginacaoComponenteListagem = novaPagina;
    this.buscar();
  }

  private controlaCamposDesabilitados(novosValores) {
    if (novosValores.sistema == 'CL') {
      if (!this.pesquisaForm.get('contrato').disabled) {
        if (this.pesquisaForm.get('contrato').value != '') {
          this.pesquisaForm.get('contrato').setValue('');
        }
        this.pesquisaForm.get('contrato').disable();
      }
    }
    else {
      if (this.pesquisaForm.get('contrato').disabled) {
        this.pesquisaForm.get('contrato').enable();
      }
    }

    if (novosValores.sistema == '89' || novosValores.sistema == '15') {
      if (!this.pesquisaForm.get('idExternoOperacao').disabled) {
        if (this.pesquisaForm.get('idExternoOperacao').value != '') {
          this.pesquisaForm.get('idExternoOperacao').setValue('');
        }
        this.pesquisaForm.get('idExternoOperacao').disable();
      }
    }
    else {
      if (this.pesquisaForm.get('idExternoOperacao').disabled) {
        this.pesquisaForm.get('idExternoOperacao').enable();
      }
    }
  }



  getParams() {
    const form = this.pesquisaForm.getRawValue();
    const params: any = {}

    if (form.idSolicitacaoDevolucao) {
      params.idSolicitacaoDevolucao = form.idSolicitacaoDevolucao;
    }

    if (form.cnpjAgenteFinanceiro) {
      params.cnpjAgenteFinanceiro = form.cnpjAgenteFinanceiro;
    }

    if (form.idEstado) {
      params.idEstado = form.idEstado;
    }

    if (form.sistema) {
      params.sistema = form.sistema;
    }

    if (form.idExternoOperacao) {
      params.idExternoOperacao = form.idExternoOperacao;
    }

    if (form.contrato) {
      params.contrato = form.contrato;
    }

    if (form.dataEnvioInicio) {
      params.dataEnvioInicio = this.datePipe.transform(form.dataEnvioInicio, 'yyyyMMdd');

    }

    if (form.dataEnvioFim) {
      params.dataEnvioFim = this.datePipe.transform(form.dataEnvioFim, 'yyyyMMdd');
    }

    return params;
  }

  buscar() {
    this.loadingService.bloqueiaTela();
    this.esconderPesquisa = true;
    const params = this.getParams();

    this.parametrosPesquisa = JSON.parse(JSON.stringify(params));

    params.pagina = this.atributosPaginacaoComponenteListagem.page;
    params.limite = this.atributosPaginacaoComponenteListagem.pageSize;

    this.solicitacaoDevolucaoHonraService.getSolicitacoesDevolucao(params).subscribe(response => {
      this.solicitacoesDevolucaoHonra = response.resultados;
      this.atributosPaginacaoComponenteListagem.count = response ? response.totalRegistrosSemPaginacao : 0;
      //this.totalObjetosRetornados = this.atributosPaginacaoComponenteListagem.count ;
      this.pesquisado = true;
      this.esconderPesquisa = false;
      this.loadingService.liberaTela();
    });

  }



  limpar() {
    this.atributosPaginacaoComponenteListagem.page = 1;
    if (!this.podeEscolherAgente) {
      this.pesquisaForm.reset({ cnpjAgenteFinanceiro: this.cnpjUsuario });
    } else {
      this.pesquisaForm.reset();
    }
    this.solicitacoesDevolucaoHonra = [];
    this.pesquisado = false;
  }

  public exportarDevolucao(): string {
    let todasDevolucaoHonra;
    let csv =` ID; AGENTE FINANCEIRO; ID. OPERAÇÃO; ID. EXT. OPERAÇÃO; SIST./CONTRATO; DATA ENVIO; ESTADO; ESTORNO MANUAL; CESTA-NUMERO\n`;

    this.loadingService.bloqueiaTela();

    this.solicitacaoDevolucaoHonraService.getSolicitacoesDevolucao(this.parametrosPesquisa).subscribe(response => {
      let tmp:string = "";

        (todasDevolucaoHonra = response ? response.resultados : undefined) &&
        todasDevolucaoHonra.forEach(devolucao =>{
          tmp += `${devolucao.id};${Utils.nomeAgentePorCNPJ(devolucao.cnpjAgenteFinanceiro,this.agentesFinanceiros)};${Utils.formataZerosAEsquerda(devolucao.idOperacao)};${Utils.formataZerosAEsquerda(devolucao.idOperacaoExterno)};${ devolucao.contratoRepasse ? devolucao.sistemaRepasse + '/' + devolucao.contratoRepasse : ''};${this.datePipe.transform(devolucao.dataEnvio,'dd/MM/yyyy HH:mm')};${devolucao.estado.nomeEstado};${devolucao.estornoManual === 'NAO' ? 'NÃO' : devolucao.estornoManual || ''};${devolucao.cestaNumero || ''}\n`;
        });
        this.loadingService.liberaTela();
        csv += tmp;
        this.exportar('DEVOLUCOES_HONRA_CSV.csv',csv);
      this.loadingService.liberaTela();
    });
     return csv;
  }

  private exportar(nomeArquivo:string , conteudoCsv:any): void{
    this.fileUtils.exportarArquivo(nomeArquivo, "\ufeff"+conteudoCsv, FileUtilsService.TEXT_CSV);
  }
}


